import React, { useState } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { AppProvider, useApp } from "@/context/AppProvider";
import { Toaster } from "sonner";
import { LoadingScreen } from "@/components/sections/LoadingScreen";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Manifesto } from "@/components/sections/Manifesto";
import { Experience } from "@/components/sections/Experience";
import { Impact } from "@/components/sections/Impact";
import { Projects } from "@/components/sections/Projects";
import { Skills } from "@/components/sections/Skills";
import { Marquee } from "@/components/sections/Marquee";
import { Certifications } from "@/components/sections/Certifications";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import { EditorToolbar } from "@/components/sections/EditorToolbar";

const SECTION_MAP = {
  manifesto: Manifesto,
  experience: Experience,
  impact: Impact,
  projects: Projects,
  skills: Skills,
  marquee: Marquee,
  certifications: Certifications,
  contact: Contact,
};

const Site = ({ ready, setReady }) => {
  const { sectionOrder } = useApp();
  return (
    <>
      <div className="noise" aria-hidden />
      <LoadingScreen onDone={() => setReady(true)} />
      <Toaster position="bottom-right" richColors />
      <Navbar />
      <main>
        <Hero ready={ready} />
        {sectionOrder.map((key) => {
          const Section = SECTION_MAP[key];
          return Section ? <Section key={key} /> : null;
        })}
      </main>
      <Footer />
      <EditorToolbar />
    </>
  );
};

function App() {
  const [ready, setReady] = useState(false);
  return (
    <AppProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <Site ready={ready} setReady={setReady} />
      </ReactLenis>
    </AppProvider>
  );
}

export default App;
